// extracted by mini-css-extract-plugin
module.exports = {"containerLanding":"Landing_containerLanding__2IV_v","button":"Landing_button__1xSkE"};